
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Brochure from "@/models/Brochure";
import { mapState } from "vuex";
import moment, * as Moment from "moment";
import { extendMoment } from "moment-range";

@Component({
  computed: mapState("BrochureAanvraag", ["selectedBrochures"])
})
export default class BrochureDetails extends Vue {
  @Prop()
  Brochure!: Brochure;

  showDescription = false;
  selected = false;

  toggle(e: Event) {
    e.preventDefault();

    this.$store.commit("BrochureAanvraag/changeSelection", {
      id: this.Brochure.id,
      selected: this.selected
    });
  }

  get header()
  {
    return this.Brochure.name + (this.Brochure.name_addition ? " " + this.Brochure.name_addition : "");
  }

  get isSelected() {
    const selBrochures =
      this.$store.state.BrochureAanvraag.selectedBrochures.map((id: string) => {
        return this.$store.state.BrochureAanvraag.brochuresById[id];
      });
    return (
      selBrochures.filter((s: Brochure) => s.id == this.Brochure.id).length > 0
    );
  }

  get canSelect() {
    return true;
  }

  get hasMultipleShippingMethods() {
    return this.$store.state.BrochureAanvraag.shippingMethods.length > 1;
  }

  get alreadySelected() {
    let alreadySelected = false;
    if (this.$store.state.BrochureAanvraag.portalProcessing != null) {
      alreadySelected =
        this.$store.state.BrochureAanvraag.portalProcessing.sessieGuids.includes(
          this.Brochure.id
        );
    }
    return alreadySelected;
  }

  @Watch("selectedBrochures", { immediate: true })
  selectedBrochuresChanged(brochureIds: string[]) {
    this.selected = !!brochureIds.find(s => s === this.Brochure.id);
  }
}
